class CustomPageTransition {

	constructor() {
		this.entered = false;
		this.pageTransition = document.querySelector(".page-transition");
	}

	leave(doneCallback) {
		this.entered = false;
		gsap.to(this.pageTransition, {
			opacity: 1,
			duration: 0.5,
			ease: 'power1.out',
			// Ne pas supprimer, sert pour naviguer à la page suivante après la transition
			onStart: () => this.pageTransition.style.pointerEvents = "initial",
			onComplete: () => doneCallback()
		});
	}

	enter(doneCallback) {
		if (this.entered) {
			return;
		}

		gsap.to(this.pageTransition, {
			opacity: 0,
			duration: 0.5,
			ease: 'power1.out',
			// Ne pas supprimer, sert pour lancer les animations après la transition
			onComplete: () => {
				this.pageTransition.style.pointerEvents = "none";
				doneCallback();
			}
		});
		this.entered = true;
	}
}
